import { Component, OnInit ,Input, Output, EventEmitter } from '@angular/core';
import {AlertController, LoadingController, ModalController} from '@ionic/angular';
import { ConfigurationModel } from 'src/app/models/configuration.model';
import { DocumentBeanQueueQueryModel } from 'src/app/models/document-bean-queue-query.model';

@Component({
  selector: 'app-document-bean-queue-filters',
  templateUrl: './document-bean-queue-filters.page.html',
  styleUrls: ['./document-bean-queue-filters.page.scss'],
})
export class DocumentBeanQueueFiltersPage implements OnInit {

  @Input() configuration: ConfigurationModel;
  @Input() documentBeanQueueQuery: DocumentBeanQueueQueryModel;
  //@Output() documentBeanQueueQueryChange: EventEmitter<DocumentBeanQueueQueryModel> = new EventEmitter<DocumentBeanQueueQueryModel>();

  loading: any;


  constructor(public modalController: ModalController,
              private alertController: AlertController) {
  }

  ngOnInit() {
      this.init();
  }

  async init() {
    
   

  
  }


  async applyFilter() {
      this.modalController.dismiss();
  }

  handleValueChange($event){

      console.log($event.target.value);
      this.configuration.documentBeanQueueOrdering = $event.target.value;
     
  }

  async selectDate(type: number) {
    // Type: 1 for fromDate; 2 for toDate.
    let date = null;
    if (type === 1) {
        date = this.documentBeanQueueQuery.fromDate;
    } else if (type === 2) {
        date = this.documentBeanQueueQuery.toDate;
    }

    const alert = await this.alertController.create({
        header: 'Select Date',
        backdropDismiss: false,
        inputs: [
            {
                name: 'date',
                type: 'date',
                value: this.generateDate(date)
            }
        ],
        buttons: [
            {
                text: 'Cancel',
                role: 'cancel',
                cssClass: 'secondary',
                handler: () => {
                    console.log('Confirm Cancel');
                }
            }, {
                text: 'Ok',
                handler: data => {
                    console.log(data);
                if (type === 1) {
                        this.documentBeanQueueQuery.fromDate = this.formDate(data.date, type);
                        // this.checkDateConsistency(1);
                        //this.documentBeanQueueQueryChange.emit( this.documentBeanQueueQuery );
                    } else if (type === 2) {
                        this.documentBeanQueueQuery.toDate = this.formDate(data.date, type);
                        //this.documentBeanQueueQueryChange.emit( this.documentBeanQueueQuery );
                        // this.checkDateConsistency(2);
                    }
                }
            }
        ]
    });
    await alert.present();
}

formDate(date: string, type:number) {
    const year = date.substr(0, 4);
    const month = date.substr(5, 2);
    const day = date.substr(8, 2);

    const resDate = new Date();
    resDate.setFullYear(+year, +month - 1, +day);

    if( type === 1){
      resDate.setHours(0, 0);
    }else{
      resDate.setHours(23, 59);
    }
    return resDate.toISOString();
}

generateDate(date: string) {
    return date.substr(0, 10);
}

generateTime(time: string, type: number) {
    if (type === 1) {
        return this.configuration.standardContractTime ?
            this.configuration.standardContractTime : time.substr(11, 2) + ':' + time.substr(14, 2);
    } else if (type === 2) {
        return this.configuration.standardReturnTime ?
            this.configuration.standardReturnTime : time.substr(11, 2) + ':' + time.substr(14, 2);
    } else {
        return time.substr(11, 2) + ':' + time.substr(14, 2);
    }
}

datesValid() {
    if( this.documentBeanQueueQuery.fromDate > this.documentBeanQueueQuery.toDate ){
        // error popup here
        return false;
    }else{
        return true;
    }
}


}
